<template>
  <div id="main-content" class="taskboard">
    <div class="container-fluid">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-6 col-md-8 col-sm-12">
            <h2>
              <a
                href="javascript:void(0);"
                class="btn btn-xs btn-link btn-toggle-fullwidth"
                ><i class="fa fa-arrow-left"></i
              ></a>
              Tickets
            </h2>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="index.html"><i class="icon-home"></i></a>
              </li>
              <li class="breadcrumb-item">Apps</li>
              <li class="breadcrumb-item active">Tickets</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row clearfix">
        <div class="col-lg-12 col-md-12">
          <div class="card">
            <div class="header">
              <h2>Area Owner Page</h2>
            </div>
            <!-- <div :style="{ display: 'flex', flexDirection: 'row', padding: '0px 20px' }">
                <input v-model="searchKey" class="form-control" placeholder="Search here..." type="text" @keyup.enter="init">
                <button type="button" class="btn btn-default" @click="init"><i class="icon-magnifier"></i></button>
            </div> -->
            <div :style="{ display: 'flex', flexDirection: 'row', padding: '0px 20px' }">
              <select class="form-control col-2" :id="'questionStatus'" v-model="searchStatus" @change="dataChanged" >
                <option v-for="(list, index) in qsList" :key="index" :value="list['id']">{{ list['name'] }}</option>
              </select>
              <select class="form-control col-1" :id="'evidenceList'" v-model="searchEvidence" @change="dataEvidenceChanged" >
                <option v-for="(list, index) in evidenceList" :key="index" :value="list['id']">{{ list['name'] }}</option>
              </select>
              <input v-model="searchKey" class="form-control" placeholder="Search here..." type="text" @keyup.enter="init">
              <button type="button" class="btn btn-default" @click="init"><i class="icon-magnifier"></i></button>
            </div>
            <div class="body">
              <app-modal
                :elements="modalElements"
                v-on:confirm="del"
              ></app-modal>
              <app-modal
                :elements="approveModalElements"
                v-on:confirm="approve"
              ></app-modal>
              <app-modal
                :elements="rejectModalElements"
                v-on:confirm="reject"
              ></app-modal>
              <button type="button" class="btn btn-outline-info" @click="edit">
                Edit <i class="far fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-success"
                style="margin-left: 20px;"
                data-toggle="modal"
                :data-target="`#${approveModalElements.modalId}`"
              >
                Approve <i class="fa fa-thumbs-up"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                style="margin-left: 20px;"
                data-toggle="modal"
                :data-target="`#${rejectModalElements.modalId}`"
              >
                Reject <i class="fa fa-thumbs-down"></i>
              </button>
              <app-datatable
                :type="'view'"
                :elements="dtElements"
                :collections="ticket"
                v-on:selectedRow="selectRow"
                :canMultiple="true"
                v-on:selectedDatas="selectDatas"
              ></app-datatable>
              <app-data-pagination
                v-on:pageChanged="changePage"
              ></app-data-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import { ticket } from "../../models/ticket";
import AppDatatable from "../../components/AppDatatable.vue";
import AppModal from "../../components/AppModal.vue";
import AppDataPagination from "../../components/AppDataPagination.vue";
import AppDataSearch from "../../components/AppDataSearch.vue";

export default {
  components: {
    AppDatatable,
    AppModal,
    AppDataPagination,
    AppDataSearch,
  },
  data() {
    return {
      ticket: [ticket],
      dtElements: [
        {
          title: "CPAR No.",
          column: "cparNo",
          type: "text",
        },
        {
          title: "Department",
          column: "department",
          type: "text",
        },
        {
          title: "Employee Name",
          column: "employeeName",
          type: "text",
        },
        {
          title: "Date",
          column: "date",
          type: "date",
        },
        {
          title: "Employee Number",
          column: "employeeNumber",
          type: "text",
        },
        {
          title: "Assigned To",
          column: "assignedTo",
          type: "text",
        },
        {
          title: 'Evidence',
          column: 'evidence',
          type: 'text'
        },
        {
          title: "Question Status",
          column: "questionStatus",
          type: "badge",
        },
      ],
      modalElements: {
        modalId: "request-sample",
        title: "Confirm",
        content: "Are you sure to delete this data?",
      },
      approveModalElements: {
        modalId: "qbo-approve",
        title: "Confirm Approve",
        content: "Are you sure to approve this data(s)?",
      },
      rejectModalElements: {
        modalId: "qbo-reject",
        title: "Confirm Reject",
        content: "Are you sure to reject this data(s)?",
      },
      selectedId: "",
      searchKey: "",
      searchStatus: '',
      searchEvidence: 'All',
      pagination: {
        pageSize: 10,
        currentPage: 1,
      },
      qsList: [],
      evidenceList: [
        {
          id: 'All',
          name: 'All'
        },
        {
          id: 'Yes',
          name: 'Yes'
        },
        {
          id: 'No',
          name: 'No'
        },
      ],
    };
  },
  async created() {
    this.init();
  },
  methods: {
    async init() {
      const ticketApi = api("task-list/partial");
      const query = {
        params: {
          searchKey: this.searchKey,
          searchStatus: this.searchStatus,
          searchEvidence: this.searchEvidence,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      this.ticket = await ticketApi.getWithQuery(query);

      const qsApi = api('question-status')
      this.qsList = await qsApi.get()
    },
    add() {
      this.$router.push({ name: "areaOwnerDetail" });
    },
    edit() {
      console.log(this.selectedDatas);
      if(this.selectedDatas.length == 0 || this.selectedDatas.length > 1) {
        // do nothing
      } else if (this.selectedDatas.length == 1) {
        this.$router.push({
          name: "areaOwnerDetail",
          query: {
            id: this.selectedDatas,
          },
        });
      }
      // if (this.selectedDatas !== "") {
      //   this.$router.push({
      //     name: "areaOwnerDetail",
      //     query: {
      //       id: this.selectedDatas,
      //     },
      //   });
      // }
    },
    preview() {},
    async del() {
      // if(this.selectedId !== '') {
      //     const rsApi = api('request-sample')
      //     await rsApi.delete(this.selectedId)
      //     this.init()
      // }
    },
    async approve() {
      if (this.selectedDatas.length > 0) {
        for (let i = 0; i < this.selectedDatas.length; i++) {
          const aoApi = api("area-owner-approve");
          await aoApi.update(
            {
              id: this.selectedDatas[i],
              ownerAreaRemark: "",
            },
            this.selectedDatas[i]
          );
        }
        this.init();
      }
    },
    async reject() {
      if (this.selectedDatas.length > 0) {
        for (let i = 0; i < this.selectedDatas.length; i++) {
          const rejApi = api("area-owner-reject");
          await rejApi.update(
            {
              id: this.selectedDatas[i],
              ownerAreaRemark: "Bulk Reject by Owner Area",
            },
            this.selectedDatas[i]
          );
        }
        this.init();
      }
    },
    selectRow(id) {
      this.selectedId = id;
    },
    selectDatas(data) {
      this.selectedDatas = data;
    },
    changePage(payload) {
      this.pagination = payload;
      this.init();
    },
    search(searchKey) {
      this.searchKey = searchKey;
      this.init();
    },
    dataChanged(evt) {
      console.log('newdata', evt.target.value)
      this.searchStatus = evt.target.value
    },
    dataEvidenceChanged(evt) {
      console.log('newdata', evt.target.value)
      this.searchEvidence = evt.target.value
    }
  },
};
</script>
